import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NewRegistrationStep1Page } from './new-registration-step1';

import { BrMaskerModule } from 'brmasker-ionic-3';

@NgModule({
  declarations: [
    NewRegistrationStep1Page,
  ],
  imports: [
    IonicPageModule.forChild(NewRegistrationStep1Page),
    BrMaskerModule,
  ],
  exports: [
    NewRegistrationStep1Page
  ]
})
export class NewRegistrationStep1PageModule { }



// WEBPACK FOOTER //
// ./src/pages/new-registration-step1/new-registration-step1.module.ts